import APP_CONST from '@/constants/AppConst';
import APP_UTILITIES from '@/utilities/commonFunctions';
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class AccountSettings extends Vue {
  public color: string = '';
  public logo: string = '';
  public slug: string = '';

  get accentColor() {
    try {
      const accountConfig = JSON.parse(
        String(localStorage.getItem('accountDesign'))
      );
      return this.color || accountConfig.accountDesign.accentColor;
    }
    catch (error) {
      console.error(error);
      return '';
    }
  }

  get accountLogoURL() {
    try {
      const accountConfig = JSON.parse(
        String(localStorage.getItem('accountDesign'))
      );
      if (this.logo == 'undefined.svg') {
        const logo = localStorage.getItem('logo');
        return logo;
      }
      return this.logo || accountConfig.accountDesign.logoUrl;
    }
    catch (error) {
      console.error(error);
      return '';
    }
  }

  get accountSlug() {
    const accountConfig = JSON.parse(
      String(localStorage.getItem('accountDesign'))
    );
    return this.slug || accountConfig.slug;
  }

  beforeMount() {
    let accountDesign: any =
      APP_UTILITIES.getCookie('accountDesign') ||
      JSON.parse(String(localStorage.getItem('accountDesign'))) ||
      '';
    if (typeof accountDesign !== 'object') {
      accountDesign = JSON.parse(accountDesign);
    }
    this.updateAccountDesignData(accountDesign);
  }

  updateAccountDesignData(accountDesign: any) {
    this.slug = accountDesign && accountDesign.slug;
    this.color = accountDesign && accountDesign.accentColor;
    const urlParts: any =
      accountDesign.logoUrl && accountDesign.logoUrl.split('/');
    if (urlParts && urlParts[APP_CONST.THREE] == 'accountslug') {
      this.logo = accountDesign.logoUrl;
      localStorage.setItem('logo', this.logo);
    }
    else {
      const logoUrl =
        accountDesign.logoUrl &&
        accountDesign.logoUrl.substr(0, accountDesign.logoUrl.lastIndexOf('.'));
      this.logo = logoUrl + '.svg';
    }
  }
}
